/**
 * 說明 : 驗證資料與後端調用的非同步行為
 */

// ----- import from redux toolkit -----
import { createAsyncThunk } from "@reduxjs/toolkit";

// ----- import from Base API -----
import BaseAPI from "./BaseAPI";

export const login = createAsyncThunk(
    "auth/login",
    async ({ account, password }, { rejectWithValue }) => {
        try {
            const data = await BaseAPI.post("/login", { account: account, password: password });
            return data;
        } catch (err) {
            console.error('login error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

export const authenticate = createAsyncThunk(
    "auth/authenticate",
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.getWithAuth("/login/auth", null, token);
            return data;
        } catch (err) {
            console.error('login error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);

export const logout = createAsyncThunk(
    "auth/logout",
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const data = await BaseAPI.deleteWithAuth("/logout", null, token);
            return data;
        } catch (err) {
            console.error('logout error', err.response.data);
            return rejectWithValue(err.response.data);
        }
    }
);